module.exports = __webpack_public_path__ + "img/icons8-lamborghini.2c5b67ed.svg";